import { getAccountContext, setAccountContext, setSelectedBrandId } from '@/store/api'
import { showCreateBrandModal } from './create-brand-modal'
import { functions } from '@/core/firebase'
import { httpsCallable } from 'firebase/functions'
import { showAssignBranchModal } from './assign-branch-modal'
import { initializeAccountContext } from '@/account/init'
import { currentUser } from '@/core/state'
import { showLoading, hideLoading } from '@/core/ui'

export function renderBrandList(containerId: string): void {
  const container = document.getElementById(containerId)
  if (!container) {
    console.warn(`[BRAND_LIST] Container #${containerId} not found`)
    return
  }

  const { userBrands = [], selectedBrandId, userBranches = [] } = getAccountContext()

  let listHTML = ''
  if (userBrands.length > 0) {
    listHTML = userBrands
      .map(
        (brand) => {
          const branchesForThisBrand = userBranches.filter(
            (branch) => branch.brandId === brand.brandId
          )

          let branchListHTML = ''
          if (branchesForThisBrand.length > 0) {
            branchListHTML = `
              <div class="mt-3 pl-2 border-l-2 border-gray-200">
                <h4 class="text-xs font-semibold text-gray-600 mb-1">Branches:</h4>
                <ul class_name="list-disc list-inside space-y-1">
                  ${branchesForThisBrand
                    .map(
                      (branch) =>
                        `<li class="text-sm text-gray-700 ml-4 list-disc">${branch.branchName}</li>`
                    )
                    .join('')}
                </ul>
              </div>`
          } else {
            branchListHTML = `
              <div class="mt-3 pl-2">
                <p class="text-sm text-gray-400 italic">No branches assigned to this brand.</p>
              </div>`
          }
          
          return `
            <div class="border border-gray-200 rounded-lg p-4 hover:border-indigo-300 transition-colors">
              <div class="flex items-center justify-between">
                <div>
                  <h3 class="font-semibold text-gray-900">${brand.brandName || brand.brandId}</h3>
                  <p class="text-sm text-gray-500">
                    Brand ID: <span class="font-mono">${brand.brandId}</span>
                  </p>
                  
                  ${branchListHTML} 

                </div>
                <div class="text-right">
                  ${
                    brand.brandId === selectedBrandId
                      ? `<span class="inline-block px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">Selected</span>`
                      : `<button
                            class="select-brand-btn text-indigo-600 hover:text-indigo-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 px-3 py-1 rounded-md"
                            data-brand-id="${brand.brandId}"
                          >
                            Select
                          </button>`
                  }
                </div>
              </div>
              <div class="mt-4 flex items-center justify-end gap-3">
                
                <button
                  type="button"
                  class="brand-assign-btn text-green-600 hover:text-green-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 px-3 py-1 rounded-md"
                  data-brand-id="${brand.brandId}"
                  data-brand-name="${brand.brandName || brand.brandId}"
                >
                  Assign Branch
                </button>
                <button
                  type="button"
                  class="brand-rename-btn text-indigo-600 hover:text-indigo-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 px-3 py-1 rounded-md"
                  data-brand-id="${brand.brandId}"
                >
                  Rename
                </button>
              </div>
            </div>
          `
        },
      )
      .join('')
  } else {
    listHTML = `
      <div class="text-center py-8 text-gray-500">
        <svg class="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h6.75M9 10.5h6.75M9 14.25h6.75M9 18h6.75" />
        </svg>
        <p>No brands found. Create your first one!</p>
      </div>
    `
  }

  // --- THIS IS THE FIX ---
  // 1. Find all branches that are "orphaned" (brandId is null or undefined)
  const unassignedBranches = userBranches.filter(b => !b.brandId || b.brandId === null)
  let unassignedBranchesHTML = ''

  if (unassignedBranches.length > 0) {
    // 2. Build a new card just for them
    unassignedBranchesHTML = `
      <div class="border border-gray-200 rounded-lg p-4 bg-gray-50">
        <div class="flex items-center justify-between">
          <div>
            <h3 class="font-semibold text-gray-900">Unassigned Branches</h3>
            <p class="text-sm text-gray-500">
              These branches are not yet assigned to a brand.
            </p>
            
            <div class="mt-3 pl-2 border-l-2 border-gray-200">
              <ul class_name="list-disc list-inside space-y-1">
                ${unassignedBranches
                  .map(
                    (branch) =>
                      `<li class="text-sm text-gray-700 ml-4 list-disc">${branch.branchName}</li>`
                  )
                  .join('')}
              </ul>
            </div>

          </div>
          <div class="text-right">
            </div>
        </div>
        <div class="mt-4 flex items-center justify-end gap-3">
          </div>
      </div>
    `
  }
  // --- END FIX ---

  container.innerHTML = `
    <div class="bg-white rounded-lg shadow-md p-6">
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-2xl font-bold text-gray-900">
          My Brands
        </h2>
        <button
          id="create-new-brand-btn"
          class="bg-indigo-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-indigo-700 transition-colors flex items-center gap-2"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          Create New Brand
        </button>
      </div>

      <div class="mb-4 text-sm text-gray-600 bg-blue-50 p-4 rounded-md border border-blue-200">
        Brands are top-level containers for your branches. Select a brand to filter the branches and data you see across the dashboard.
      </div>

      <div class="space-y-3">
        ${listHTML}
        ${unassignedBranchesHTML} </div>
    </div>
  `

  container.querySelector('#create-new-brand-btn')?.addEventListener('click', () => {
    
    showCreateBrandModal(async () => {
      // Refresh the entire state
      showLoading({ message: 'Refreshing account data...' })
      if (currentUser) {
        await initializeAccountContext(currentUser.uid)
      }
      hideLoading()
      
      // Re-render this list with the new data
      renderBrandList(containerId)
    })
  })

  // Job 3 Listener
  container.querySelectorAll('.brand-assign-btn').forEach((button) => {
    button.addEventListener('click', () => {
      const brandId = (button as HTMLElement).dataset.brandId
      const brandName = (button as HTMLElement).dataset.brandName
      if (!brandId || !brandName) return

      showAssignBranchModal({ brandId, brandName }, async () => {
        // This is the refresh callback
        showLoading({ message: 'Refreshing account data...' })
        if (currentUser) {
          await initializeAccountContext(currentUser.uid)
        }
        hideLoading()

        // Re-render this list to show the newly assigned branch
        renderBrandList(containerId)
      })
    })
  })

  // "Select" buttons for each brand
  container.querySelectorAll('.select-brand-btn').forEach((button) => {
    button.addEventListener('click', () => {
      const brandId = (button as HTMLElement).dataset.brandId
      if (brandId) {
        // 1. Set the new brand in the store AND localStorage
        setSelectedBrandId(brandId)
        
        // 2. Force a full page reload.
        window.location.reload()
      }
    })
  })

  // --- Rename Brand Listener (Modal Version) ---
  container.querySelectorAll('.brand-rename-btn').forEach((button) => {
    button.addEventListener('click', async () => {
      const brandId = (button as HTMLElement).dataset.brandId
      if (!brandId) return

      const brand = getAccountContext().userBrands.find((b) => b.brandId === brandId)
      const currentName = brand?.brandName || ''

      // Dynamically import the modal
      const { showRenameModal } = await import('../components/rename-modal')

      showRenameModal({
        title: 'Rename Brand',
        label: 'Brand Name',
        currentName: currentName,
        onRename: async (newName) => {
          const updateBrandName = httpsCallable(functions, 'updateBrandName')
          await updateBrandName({ brandId: brandId, newName: newName })

          // Reload to reflect name change globally
          window.location.reload()
        }
      })
    })
  })
}
